import { Col, Layout, Row, Skeleton } from 'antd'
import { Navigate, Outlet, useNavigate, useParams } from 'react-router-dom'
import { LayoutFooter } from './components/LayoutFooter'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import {
  getProfileWithSlug,
  resetProfileQueryAndIds,
  selectSelectedProfile,
  setSelectedProfileWithSlug,
} from '../store/ProfileReducer'
import ProfileHeader from './components/ProfileHeader'
import { resetContactQueryAndIds } from '../store/ContactReducer'
import { initialQuery } from '../models/helper'
import { resetAnalyticsEventQueryAndIds } from '../store/AnalyticsEventReducer'
import { resetAutomationQueryAndIds } from '../store/AutomationReducer'
import { resetAnswerQueryAndIds } from '../store/AnswerReducer'
import { Subscription } from '../components/subscription/Subscription'
import { isSubscriptionValid } from '../models/Billing'

const { Content } = Layout

export const ProfileLayout: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { profileSlug } = useParams<{ profileSlug: string }>()
  const { isLoading } = useAppSelector((state) => state.profile)
  const profile = useAppSelector(selectSelectedProfile())

  useEffect(() => {
    if (!profileSlug) return

    // Only on init we want to reset ids
    // To avoid seeing old items from previous page table
    dispatch(resetAutomationQueryAndIds(initialQuery))
    dispatch(resetAnswerQueryAndIds(initialQuery))
    dispatch(resetContactQueryAndIds(initialQuery))
    dispatch(resetAnalyticsEventQueryAndIds(initialQuery))

    dispatch(getProfileWithSlug(profileSlug))
      .then(() => {
        dispatch(setSelectedProfileWithSlug(profileSlug))
      })
      .catch(() => {
        navigate('/')
      })
  }, [dispatch, profileSlug])

  if (!profile) {
    return <Skeleton loading />
  }

  if (!isSubscriptionValid(profile.subscription)) {
    return <Navigate to="/" />
  }

  return (
    <Layout>
      <ProfileHeader />
      <Layout style={{ minHeight: 'calc(100vh - 64px)', marginTop: 102 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              {!isLoading && <Outlet />}
            </Col>
          </Row>
        </Content>
      </Layout>
    </Layout>
  )
}
